(function () {
  // 横スクロールの矢印（PC）
  function initScroller(root) {
    if (root.dataset.coordInit) return;
    root.dataset.coordInit = '1';
    var track = root.querySelector('.coord-track');
    var prev = root.querySelector('.coord-arrow--prev');
    var next = root.querySelector('.coord-arrow--next');
    if (!track || !prev || !next) return;
    function update() {
      prev.disabled = track.scrollLeft <= 4;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    }
    function step(dir) {
      var card = track.firstElementChild;
      var w = card ? card.getBoundingClientRect().width + 16 : track.clientWidth;
      track.scrollBy({ left: dir * w * 2, behavior: 'smooth' });
    }
    prev.addEventListener('click', function () { step(-1); });
    next.addEventListener('click', function () { step(1); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  // スライド位置の共通処理（左寄せのフィルムストリップ）
  function slider(track) {
    var slides = track.children;
    function stepWidth() { return slides.length > 1 ? Math.max(1, slides[1].offsetLeft - slides[0].offsetLeft) : track.clientWidth; }
    return {
      count: slides.length,
      current: function () {
        // 右端までスクロールしたら最後の画像
        if (track.scrollLeft > 4 && track.scrollLeft + track.clientWidth >= track.scrollWidth - 4) return slides.length - 1;
        return Math.min(slides.length - 1, Math.round(track.scrollLeft / stepWidth()));
      },
      go: function (i, instant) {
        i = Math.max(0, Math.min(slides.length - 1, i));
        track.scrollTo({ left: i * stepWidth(), behavior: instant ? 'auto' : 'smooth' });
      }
    };
  }

  // 詳細ページのギャラリー（スワイプ + カウンター + サムネイル + 拡大表示）
  function initGallery(root) {
    if (root.dataset.coordInit) return;
    root.dataset.coordInit = '1';
    var track = root.querySelector('.coord-gallery__track');
    if (!track) return;
    var s = slider(track);
    var counter = root.querySelector('[data-coord-current]');
    var dots = root.querySelectorAll('.coord-gallery__dots button, .coord-gallery__thumbs button');
    function update() {
      var i = s.current();
      if (counter) counter.textContent = i + 1;
      dots.forEach(function (d) { d.setAttribute('aria-current', String(Number(d.dataset.index) === i)); });
    }
    dots.forEach(function (d) { d.addEventListener('click', function () { s.go(Number(d.dataset.index)); }); });
    var p = root.querySelector('.coord-gallery__nav--prev');
    var n = root.querySelector('.coord-gallery__nav--next');
    if (p) p.addEventListener('click', function () { s.go(s.current() - 1); });
    if (n) n.addEventListener('click', function () { s.go(s.current() + 1); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    update();

    // 拡大表示
    var box = root.parentElement.querySelector('[data-coord-lightbox]');
    if (!box) return;
    document.body.appendChild(box); // テーマのアニメーション(transform)の影響を受けないように body 直下へ
    var boxTrack = box.querySelector('.coord-lightbox__track');
    var boxCounter = box.querySelector('[data-coord-lightbox-current]');
    var bs = slider(boxTrack);
    var lastFocus = null;
    function boxUpdate() { if (boxCounter) boxCounter.textContent = bs.current() + 1; }
    function open(i) {
      lastFocus = document.activeElement;
      box.querySelectorAll('img[data-src]').forEach(function (img) { img.src = img.dataset.src; img.removeAttribute('data-src'); });
      box.hidden = false;
      document.documentElement.classList.add('coord-lightbox-open');
      requestAnimationFrame(function () { bs.go(i, true); boxUpdate(); });
      box.querySelector('.coord-lightbox__close').focus();
    }
    function close() {
      box.hidden = true;
      document.documentElement.classList.remove('coord-lightbox-open');
      s.go(bs.current(), true);
      if (lastFocus) lastFocus.focus();
    }
    root.querySelectorAll('[data-coord-zoom]').forEach(function (b) {
      b.addEventListener('click', function () { open(Number(b.dataset.coordZoom)); });
    });
    box.querySelector('.coord-lightbox__close').addEventListener('click', close);
    var bp = box.querySelector('.coord-lightbox__nav--prev');
    var bn = box.querySelector('.coord-lightbox__nav--next');
    if (bp) bp.addEventListener('click', function () { bs.go(bs.current() - 1); });
    if (bn) bn.addEventListener('click', function () { bs.go(bs.current() + 1); });
    boxTrack.addEventListener('scroll', function () { window.requestAnimationFrame(boxUpdate); }, { passive: true });
    document.addEventListener('keydown', function (e) {
      if (box.hidden) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') bs.go(bs.current() - 1);
      if (e.key === 'ArrowRight') bs.go(bs.current() + 1);
    });
  }

  // 一覧ページ：男の子・女の子の絞り込み + スクロールで自動表示
  function initList(root) {
    if (root.dataset.coordInit) return;
    root.dataset.coordInit = '1';
    var step = Number(root.dataset.step || 20);
    var items = Array.prototype.slice.call(root.querySelectorAll('.coord-grid > [data-gender]'));
    var countEl = root.querySelector('[data-coord-count]');
    var noResult = root.querySelector('[data-coord-noresult]');
    var sentinel = root.querySelector('[data-coord-sentinel]');
    var buttons = root.querySelectorAll('[data-coord-gender]');
    var gender = '';
    var shown = step;

    function matches(el) { return !gender || el.dataset.gender === gender || el.dataset.gender === 'both'; }
    function render() {
      var matched = items.filter(matches);
      items.forEach(function (el) { el.hidden = true; });
      matched.slice(0, shown).forEach(function (el) { el.hidden = false; });
      if (countEl) countEl.textContent = matched.length;
      if (noResult) noResult.hidden = matched.length > 0;
      if (sentinel) sentinel.hidden = matched.length <= shown;
    }
    buttons.forEach(function (b) {
      b.addEventListener('click', function () {
        gender = b.dataset.coordGender;
        buttons.forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
        shown = step;
        render();
        try { var u = new URL(location.href); if (gender) u.searchParams.set('gender', gender); else u.searchParams.delete('gender'); history.replaceState(null, '', u); } catch (e) {}
      });
    });
    // URL に ?gender=boy / girl があれば最初から絞り込む
    try {
      var g = new URL(location.href).searchParams.get('gender');
      if (g === 'boy' || g === 'girl') {
        gender = g;
        buttons.forEach(function (x) { x.setAttribute('aria-pressed', String(x.dataset.coordGender === g)); });
      }
    } catch (e) {}
    render();

    // 下までスクロールしたら次の分を表示（画面に余裕があれば続けて表示）
    var ticking = false;
    function check() {
      ticking = false;
      if (!sentinel || sentinel.hidden) return;
      if (sentinel.getBoundingClientRect().top < window.innerHeight + 400) {
        shown += step;
        render();
        window.requestAnimationFrame(check);
      }
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(check); }
    }, { passive: true });
    buttons.forEach(function (b) { b.addEventListener('click', function () { window.requestAnimationFrame(check); }); });
    check();
  }

  // トップ：タブ切り替え（ランキングと同じ見せ方）
  function initTabs(root) {
    if (root.dataset.coordInit) return;
    root.dataset.coordInit = '1';
    var tabs = root.querySelectorAll('.coord-pilltabs__tab');
    var viewAll = root.querySelector('[data-coord-viewall]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', String(on));
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
        if (viewAll && tab.dataset.more) viewAll.href = tab.dataset.more;
        window.dispatchEvent(new Event('resize'));
      });
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-coord-scroller]').forEach(initScroller);
    (scope || document).querySelectorAll('[data-coord-gallery]').forEach(initGallery);
    (scope || document).querySelectorAll('[data-coord-list]').forEach(initList);
    (scope || document).querySelectorAll('[data-coord-tabs]').forEach(initTabs);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
